import { combineReducers } from 'redux';
import { products } from './shared/reducers/products';
import { sales } from './shared/reducers/sales';
import { fields } from './shared/reducers/additionalFields';
import { appRoutes } from './routes';
import {salesTotals} from "~/apps/pos/shared/reducers/salesTotals";

export const initReducers = () => {
  return {
    pos: combineReducers({
      products,
      sales,
      fields,
      salesTotals,
    })
  };
};

export const initRoutes = () => {
  return appRoutes;
};

export const initApp = (store) => {
};
